/**
 * @typedef Variant
 * @type {object}
 * @property {string} id - Variant ID
 * @property {number} quantityAvailable
 * @property {...*} [any] - Any additional variant data
 */

/**
 * @typedef MultiComponent
 * @type {object}
 * @property {number} quantity - Quantity multiplier for this component
 * @property {Variant} variant
 */

/**
 * @typedef UnifiedComponent
 * @type {object}
 * @property {string} id - Variant ID
 * @property {number} quantityAvailable
 * @property {number} quantityEach - Quantity multiplier for this component
 * @property {Variant} variant - Variant, as input including any additional data
 */

/**
 * Takes components and multiComponents and returns them combined, in a consistent format.
 * @param {Object} param
 * @param {Variant} param.variant
 * @param {Variant[]} param.components
 * @param {MultiComponent[]} param.multiComponents
 * @returns {UnifiedComponent[]}
 */
export default function unifyComponents({
  variant,
  components,
  multiComponents,
}) {
  const unifiedComponents = [];

  if (components?.length) {
    unifiedComponents.push(
      ...components.map((variant) => {
        const { id, quantityAvailable } = variant;

        return {
          id,
          quantityAvailable,
          quantityEach: 1,
          variant,
        };
      }),
    );
  }

  if (multiComponents?.length) {
    unifiedComponents.push(
      ...multiComponents.map(({ quantity, variant }) => {
        const { id, quantityAvailable } = variant;
        const quantityEach = parseInt(quantity);

        return {
          id,
          quantityAvailable,
          quantityEach,
          variant,
        };
      }),
    );
  }

  if (!unifiedComponents.length) {
    unifiedComponents.push({
      id: variant.id,
      quantityAvailable: variant.quantityAvailable,
      quantityEach: 1,
      variant,
    });
  }

  return unifiedComponents;
}
